export class ClientError extends Error {
  constructor(message: any) {
    super();
    this.message = message;
  }
  getErrorMessage() {
    return this.message;
  }
}
